/*

Syntax - do not replace arrow functions- they are needed to preserve references to the class.

/**
 * @license
 * Lodash (Custom Build) lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
 * Build: `lodash include="debounce"`
 */
;(function(){function t(){}function e(t){return null==t?t===l?m:p:I&&I in Object(t)?n(t):o(t)}function n(t){var e=$.call(t,I),n=t[I];try{t[I]=l;var o=true}catch(t){}var r=_.call(t);return o&&(e?t[I]=n:delete t[I]),r}function o(t){return _.call(t)}function r(t,e,n){function o(e){var n=d,o=j;return d=j=l,h=e,g=t.apply(o,n)}function r(t){return h=t,O=setTimeout(a,e),T?o(t):g}function u(t){var n=t-x,o=t-h,r=e-n;return S?W(r,v-o):r}function f(t){var n=t-x,o=t-h;return x===l||n>=e||n<0||S&&o>=v}function a(){
var t=k();return f(t)?s(t):(O=setTimeout(a,u(t)),l)}function s(t){return O=l,w&&d?o(t):(d=j=l,g)}function p(){O!==l&&clearTimeout(O),h=0,d=x=j=O=l}function y(){return O===l?g:s(k())}function m(){var t=k(),n=f(t);if(d=arguments,j=this,x=t,n){if(O===l)return r(x);if(S)return O=setTimeout(a,e),o(x)}return O===l&&(O=setTimeout(a,e)),g}var d,j,v,g,O,x,h=0,T=false,S=false,w=true;if(typeof t!="function")throw new TypeError(b);return e=c(e)||0,i(n)&&(T=!!n.leading,S="maxWait"in n,v=S?M(c(n.maxWait)||0,e):v,w="trailing"in n?!!n.trailing:w),
m.cancel=p,m.flush=y,m}function i(t){var e=typeof t;return null!=t&&("object"==e||"function"==e)}function u(t){return null!=t&&typeof t=="object"}function f(t){return typeof t=="symbol"||u(t)&&e(t)==y}function c(t){if(typeof t=="number")return t;if(f(t))return s;if(i(t)){var e=typeof t.valueOf=="function"?t.valueOf():t;t=i(e)?e+"":e}if(typeof t!="string")return 0===t?t:+t;t=t.replace(d,"");var n=v.test(t);return n||g.test(t)?O(t.slice(2),n?2:8):j.test(t)?s:+t}var l,a="4.17.5",b="Expected a function",s=NaN,p="[object Null]",y="[object Symbol]",m="[object Undefined]",d=/^\s+|\s+$/g,j=/^[-+]0x[0-9a-f]+$/i,v=/^0b[01]+$/i,g=/^0o[0-7]+$/i,O=parseInt,x=typeof global=="object"&&global&&global.Object===Object&&global,h=typeof self=="object"&&self&&self.Object===Object&&self,T=x||h||Function("return this")(),S=typeof exports=="object"&&exports&&!exports.nodeType&&exports,w=S&&typeof module=="object"&&module&&!module.nodeType&&module,N=Object.prototype,$=N.hasOwnProperty,_=N.toString,E=T.Symbol,I=E?E.toStringTag:l,M=Math.max,W=Math.min,k=function(){
return T.Date.now()};t.debounce=r,t.isObject=i,t.isObjectLike=u,t.isSymbol=f,t.now=k,t.toNumber=c,t.VERSION=a,typeof define=="function"&&typeof define.amd=="object"&&define.amd?(T._=t, define(function(){return t})):w?((w.exports=t)._=t,S._=t):T._=t}).call(this);

let localID = 0;
class SitegurusLiveUpdate {
  constructor(options) {
    //Validation
    if(typeof options !== 'object') {
      throw new Error('Live Updates Setup Error:: Must provide options object to SitegurusLiveUpdate constructor.');
    }
    //Options
    const {element,publicKey,liveUpdateComponents,suspenseHTML = null,suspenseCSSClassList = null,defaultParams = {},autoEventListeners = false,sortHTML = {
      unsorted: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5">
          <path fill-rule="evenodd" d="M2.24 6.8a.75.75 0 001.06-.04l1.95-2.1v8.59a.75.75 0 001.5 0V4.66l1.95 2.1a.75.75 0 101.1-1.02l-3.25-3.5a.75.75 0 00-1.1 0L2.2 5.74a.75.75 0 00.04 1.06zm8 6.4a.75.75 0 00-.04 1.06l3.25 3.5a.75.75 0 001.1 0l3.25-3.5a.75.75 0 10-1.1-1.02l-1.95 2.1V6.75a.75.75 0 00-1.5 0v8.59l-1.95-2.1a.75.75 0 00-1.06-.04z" clip-rule="evenodd" />
        </svg>
      `,
      asc: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5">
          <path fill-rule="evenodd" d="M10 15a.75.75 0 01-.75-.75V7.612L7.29 9.77a.75.75 0 01-1.08-1.04l3.25-3.5a.75.75 0 011.08 0l3.25 3.5a.75.75 0 11-1.08 1.04l-1.96-2.158v6.638A.75.75 0 0110 15z" clip-rule="evenodd" />
        </svg>
      `,
      desc: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5">
          <path fill-rule="evenodd" d="M10 5a.75.75 0 01.75.75v6.638l1.96-2.158a.75.75 0 111.08 1.04l-3.25 3.5a.75.75 0 01-1.08 0l-3.25-3.5a.75.75 0 111.08-1.04l1.96 2.158V5.75A.75.75 0 0110 5z" clip-rule="evenodd" />
        </svg>
      `
    }, modifyHistory = {enabled: false, includeHiddenFields: false}} = options;
    //Validation
    
    if(!element) {
      throw new Error('Live Updates Setup Error:: Must specify a DOM element in the options when using SitegurusLiveUpdate constructor.');
    }
    if(!publicKey && !element.hasAttribute('data-sg-live-update-key')) {
      throw new Error('Live Updates Setup Error:: Must provide public key from the Liquid function to SitegurusLiveUpdate constructor.');
    }
    //Set
    this.log = [];
    this.element = element;
    this.publicKey = publicKey || element.getAttribute('data-sg-live-update-key');
    var pathname = window.location.pathname.split('/');
    if(pathname[1]) {
      defaultParams['referrerSlug'] = pathname[1];
    }
    if(pathname[2]) {
      defaultParams['referrerSlug2'] = pathname[2];
    }
    if(pathname[3]) {
      defaultParams['referrerSlug3'] = pathname[3];
    }
    if(pathname[4]) {
      defaultParams['referrerSlugs'] = pathname[pathname.length];
    }
    this.defaultParams = defaultParams;
    if(Array.isArray(liveUpdateComponents)) {
      if(liveUpdateComponents.length > 0) {
        liveUpdateComponents.forEach((item) => {
          if(!item.id && !item.hasAttribute('data-sg-live-update-component') ) {
            throw new Error('Live Updates Setup Error:: elements passed to liveUpdateComponents options must either have a unique ID attribute or a unique data-attribute of data-sg-live-update-component.')
          }
        });
        this.liveUpdateComponents = liveUpdateComponents;
        this.liveUpdateBehaviour = "Live-update only specified components."
      }
    } else if(liveUpdateComponents) {
      console.error('Live Updates Setup Error:: liveUpdateComponents expects an array of elements. If you are using document.querySelectorAll, wrap the NodeList in an Array.from() function.')
    }
    if(!this.liveUpdateComponents) {
      this.liveUpdateComponents = null;
      this.liveUpdateBehaviour = "Live-update entire layout innerHTML."
    }
    if(!element.dataset.sgLiveUpdateSection) {
      localID++;
    }
    this.uniqID = element.dataset.sgLiveUpdateSection ? element.dataset.sgLiveUpdateSection : localID;
    this.suspenseHTML = suspenseHTML;
    this.suspenseCSSClassList = suspenseCSSClassList;
    this.autoEventListeners = autoEventListeners;
    if(this.autoEventListeners === true) {
      this.setDefaultEventListeners();
    }
    this.sortHTML = sortHTML;
    this.modifyHistory = modifyHistory;
    this.initialised = true;

    //Make object accessible globally.
    if(!window.sgLiveUpdateConfig) {
      window.sgLiveUpdateConfig = {};
    }
    window.sgLiveUpdateConfig[this.uniqID] = this;
    this.changeStateTrailingDebounce = _.debounce(this.changeState, 500, {trailing: true});
    this.changeStateLeadingDebounce = _.debounce(this.changeState, 500, {trailing: false, leading: true});
    const live_update_constructor_ready = new CustomEvent("live_update_constructor_ready");
    document.dispatchEvent(live_update_constructor_ready);
  }
  setSuspenseCSSClassList(value) {
    this.suspenseCSSClassList = value;
  }
  setSuspenseHTML(value) {
    this.suspenseHTML = value;
  }
  setSortHTML(value) {
    this.sortHTML = value;
  }
  setDefaultParams(value) {
    this.defaultParams = value;
  }
  mergeDefaultParams(paramsObject = {}) {
    this.defaultParams = {
      ...this.defaultParams,
      ...paramsObject
    };
  }
  setModifyHistory(value) {
    if(typeof value === "object") {
      if(typeof value.includeHiddenFields === "boolean" && typeof value.enabled === "boolean") {
        this.modifyHistory = value;
      } else {
        console.error('Live Updates Setup Error: modifyHistory Object must have an enabled and an includeHiddenFields boolean property.');
      }
    } else {
      console.error('Live Updates Setup Error: modifyHistory value must be an Object.');
    }
  }
  getFormState(forms = Array.from(this.element.querySelectorAll('[data-sg-live-update-controls]')), includeHiddenFields = true) {
    const convertURLSearchStringToObject = (searchString) => {
      const searchParamsString = searchString.split('?');
      const searchParsed = new URLSearchParams(searchParamsString[1] || searchParamsString[0]);
      let newObject = {};
      searchParsed.forEach((value,key) => {
        newObject[key] = value;
      });
      return newObject;
    }
    const mergeParamsAndNewObject = (params, newObject) => {
      return {
        ...params,
        ...newObject
      }
    }
    let params = {};
    if(forms) {
      forms.forEach((form) => {
        let controls;
        if(includeHiddenFields === true) {
          controls = form.querySelectorAll('input,select,textarea,button[data-sg-live-update-control-params],button[data-sg-live-update-sort-order]');
        } else {
          controls = form.querySelectorAll('input:not([hidden]):not([type=hidden]),select:not([hidden]):not([type=hidden]),textarea:not([hidden]):not([type=hidden]),button[data-sg-live-update-control-params]:not([hidden]):not([type=hidden]),button[data-sg-live-update-sort-order]:not([hidden]):not([type=hidden])');
        }
        
        controls.forEach((control) => {
          let paramsTypeReference = params;
          if(control.hasAttribute('data-sg-live-update-default-param')) {
            paramsTypeReference = this.defaultParams;
            
          }
          if(control.hasAttribute('name') || control.tagName == 'BUTTON') {
            if(control.tagName == 'BUTTON') {
              if(control.hasAttribute('data-sg-live-update-sort-order')) {
                if(control.getAttribute('data-sg-live-update-sort-order') === 'asc' || control.getAttribute('data-sg-live-update-sort-order') === 'desc') {
                  var newParams = {
                    sort_order: control.getAttribute('data-sg-live-update-sort-order'),
                    sort_type: control.getAttribute('data-sg-live-update-sort-type')
                  }
                  paramsTypeReference = mergeParamsAndNewObject(paramsTypeReference, newParams);
                }
              } else if(control.getAttribute('aria-pressed') === 'true') {
                const btnHrefString = control.getAttribute('data-sg-live-update-control-params');
                var newParams = convertURLSearchStringToObject(btnHrefString);
                paramsTypeReference = mergeParamsAndNewObject(paramsTypeReference, newParams);
              }
            } else if((control.tagName == 'SELECT' && control.hasAttribute('multiple'))) {
              //Select multiple - does not support data-attributes for multiple parameters
              paramsTypeReference[(control.getAttribute('name'))] = Array.from(control.options).filter((opt) => {
                return opt.selected;
              }).map((opt) => {
                return opt.value;
              });
            } else if((control.tagName == "INPUT" && control.getAttribute('type') === 'checkbox')) {
              //Checkboxes - supports multiple selections. Does not support data-attributes
              if(control.checked === true) {
                if(paramsTypeReference[(control.getAttribute('name'))]) {
                  if(typeof paramsTypeReference[(control.getAttribute('name'))] === "array") {
                    paramsTypeReference[(control.getAttribute('name'))].push(control.value);
                  } else {
                    var previousValue = paramsTypeReference[(control.getAttribute('name'))];
                    paramsTypeReference[(control.getAttribute('name'))] = [previousValue, control.value];
                  }
                } else {
                  paramsTypeReference[(control.getAttribute('name'))] = control.value;
                }
              }
            } else if(control.getAttribute('type') === 'radio') {
              if(control.checked === true) {
                //Radio Supports data-attribute for query params instead of value.
                if(control.getAttribute('data-sg-live-update-control-params')) {
                  const newParams = convertURLSearchStringToObject(control.getAttribute('data-sg-live-update-control-params'));
                  paramsTypeReference = mergeParamsAndNewObject(params, newParams);
                } else {
                  paramsTypeReference[(control.getAttribute('name'))] = control.value;
                }
              }
            } else {
              //All other controls with a single value. Supports data-attribute for query params instead of value.
              if(control.getAttribute('data-sg-live-update-control-params')) {
                const newParams = convertURLSearchStringToObject(control.getAttribute('data-sg-live-update-control-params'));
                paramsTypeReference = mergeParamsAndNewObject(paramsTypeReference, newParams);
              } else {
                paramsTypeReference[(control.getAttribute('name'))] = control.value;
              }
            }
          }
          if(control.hasAttribute('data-sg-live-update-default-param')) {
            this.defaultParams = paramsTypeReference;
          } else {
            params = paramsTypeReference;
          }
        });
      });
    }
    
    return params;
  }
  liveUpdate(paramsObject, onBeforeLiveUpdate = null, onAfterLiveUpdate = null, options = {}) {
    const idempotency_id = Date.now();
    const controller = new AbortController();
    this.currentRequest = idempotency_id;
    this.log.filter((i) => i.status === 'live').forEach(
      function(log) {
        log.controller.abort({message: 'Live Updates API: Handled error, request cancelled due to newer request being made.'});
        log.status = 'aborted'
      }
    )
    this.log.push({
      idempotency_id: idempotency_id,
      details: {
        paramsObject,
        onBeforeLiveUpdate,
        onAfterLiveUpdate,
        options
      },
      controller: controller,
      status: 'live'
    });
    const passedParams = {...paramsObject};
    const onlyUpdateComponent = options.onlyUpdateComponent;
    //Merge default params with passed params.
    for(const key in this.defaultParams) {
      if(!paramsObject.hasOwnProperty(key)) {
        paramsObject[key] = this.defaultParams[key];
      }
    }
    let live_update_start = new CustomEvent("live_update_start", {
      detail: {
        reference: this,
        params: paramsObject,
        defaultParams: this.defaultParams,
        passedParams: passedParams
      }
    });
    this.element.dispatchEvent(live_update_start);
    if(typeof onBeforeLiveUpdate == 'function') {
      onBeforeLiveUpdate({instance: this, params: paramsObject,defaultParams: this.defaultParams, passedParams: passedParams});
    }
    //Loading Animation/ Suspense Component
    if(this.suspenseHTML) {
      if(this.liveUpdateComponents) {
        this.liveUpdateComponents.forEach((element, index) => {
          element.innerHTML = this.suspenseHTML;
        });
      } else {
        this.element.innerHTML = this.suspenseHTML;
      }
    }
    if(this.suspenseCSSClassList) {
      var classListArray = this.suspenseCSSClassList.split(' ');
      classListArray.forEach((className) => {
        if(this.liveUpdateComponents) {
          this.liveUpdateComponents.forEach((element, index) => {
            element.classList.add(className)
          });
        } else {
          this.element.classList.add(className);
        }
      });
    }
    let paramsString = '';
    for(const key in paramsObject) {
      if(paramsObject[key]) {
        paramsString += `&${key}=${paramsObject[key]}`;
      }
    }
    fetch(`/modules/module_86/api/front_end/v1/live_update?public_key=${this.publicKey}${paramsString}`, {
      method: 'GET',
      signal: controller.signal
    }).then(
      async (res) => {
        let json;
        try {
          json = await res.json();
          if(res.ok) {
            return json;
          }
        } catch(error) {
          this.removeSuspenseCSS();
          throw {message: 'Sorry, there was an unhandled error live-updating this content.', status: res.status }
        }
        if(!res.ok) {
          throw {message: json.message, status: res.status };
        }
      }
    ).then(
      (res) => {
        if(!res.html && paramsObject.collection !== 'true') {
          throw {message: res.message};
        } else if(res.html.includes('Liquid error:')) {
          throw { message: 'The module detected a server-side Liquid rendering error when live-updating this HTML (to find it, search the network response for "Liquid Error"). In order to prevent your users seeing the error message, the module blocked the update. Please resolve the error in order for the next update to be successful.'}
        }
        if(paramsObject.collection !== 'true') {
          var html = res.html.trim();
          var htmlParsed = new DOMParser().parseFromString(html, 'text/html');
          if(this.liveUpdateComponents) {
            this.liveUpdateComponents.forEach((element, index) => {
              const dest = element;
              const dataId = element.dataset.sgLiveUpdateComponent;
              const id = element.id;
              let idType, src;
              if(dataId) {
                idType = 'data-attribute';
              } else if(id) {
                idType = 'id';
              } else {
                throw new Error('Live Updates Setup Error:: components to be live-updated must have a unique ID or data-sg-live-update-component attribute.')
              }
              if(idType == 'id') {
                if(onlyUpdateComponent) {
                  if(!onlyUpdateComponent.includes(element.id)) {
                    return false;
                  }
                }
                src = htmlParsed.getElementById(id);
              } else if(idType == 'data-attribute') {
                if(onlyUpdateComponent) {
                  if(!onlyUpdateComponent.includes(element.dataset.sgLiveUpdateComponent)) {
                    return false;
                  }
                }
                src = htmlParsed.querySelector(`[data-sg-live-update-component='${dataId}']`);
              }
              this.removeSuspenseCSS();
              dest.outerHTML = src.outerHTML;
              //Re-reference the element in the object.
              if(idType == 'id') {
                this.liveUpdateComponents[index] = this.element.getElementById(`${id}`);
              } else if(idType == 'data-attribute') {
                this.liveUpdateComponents[index] = this.element.querySelector(`[data-sg-live-update-component=${dataId}]`);
              }
            });
          } else {
            //Support outerHTML in future.
            this.element.innerHTML = htmlParsed.querySelector('body').innerHTML;
          }
          if(this.autoEventListeners === true) {
            //Rehydrate (any elements that lost their listeners will be missing the data-attribute, so will be re-hydrated.) Note, for better experience in future, it may be useful to attach listeners to the parsed DOM before the HTML is replaced in the real DOM.
            this.setDefaultEventListeners();
          }
          const live_update_end = new CustomEvent("live_update_end", {
            detail: {
              reference: this,
              params: paramsObject,
              defaultParams: this.defaultParams,
              passedParams: passedParams,
              data: res.data
            }
          });
          this.element.dispatchEvent(live_update_end);
          if(typeof onAfterLiveUpdate == 'function') {
            onAfterLiveUpdate({instance: this, params: paramsObject, defaultParams: this.defaultParams, passedParams: passedParams, data: res.data});
          }
          if(typeof onAfterLiveUpdate == 'function') {
            onAfterLiveUpdate({instance: this, params: paramsObject, defaultParams: this.defaultParams, passedParams: passedParams, data: res.data});
          }
          const thisRequestLog = this.log.find((i) => i.idempotency_id === idempotency_id);
          if(thisRequestLog) {
            thisRequestLog.status = 'finished';
          }
        }
        
        

        
      }
    ).catch(
      (error) => {
        if(typeof error === 'object') {
          if(error.name === 'AbortError' || (error.message ? error.message === 'Live Updates API: Handled error, request cancelled due to newer request being made.' : false)) {
            //Not an issue, continue.
          } else if(error.message.includes(`Cannot read properties of null (reading 'outerHTML')`)) {
            console.error(`Live Updates Setup Error: Cannot read properties of null (reading 'outerHTML'). You might have an element marked with data-sg-live-update-component in the original document which is not included in the new updated version of the layout. Make sure any component data-attributes are included in any response, even if they are empty or hidden visually.`);
          } else {
            console.error(error.message, 'status: ', error.status? error.status : 'unhandled'); 
          } 
        } else {
          console.error(error);
        }
      }
    )
  }
  setDefaultEventListeners() {
    const forms = this.element.querySelectorAll('[data-sg-live-update-controls]');
    if(forms) {
      forms.forEach((form) => {
        if(!form.hasAttribute('data-sg-live-update-listeners-attached')) {
          form.addEventListener('submit', (event) =>{
            //If enter key is pressed on element in form, live-update immediately.
            event.preventDefault();
            //Cancel any queued keyup event
            this.changeStateTrailingDebounce.cancel();
            //Change state now.
            this.changeState(event,true,undefined);
            form.setAttribute('data-sg-live-update-listeners-attached', 'true');
          })
        }
        
        const controlElements = form.querySelectorAll('input[name],select[name],textarea[name]');
        controlElements.forEach((control) => {
          if(control.hasAttribute('data-sg-live-update-listeners-attached')) {
            return false;
          }
          if(control.tagName == 'INPUT') {
            switch(control.getAttribute('type')) {
              case 'text':
              case 'number':
              case 'email':
              case 'password':
              case 'search':
              case 'tel':
              case 'url':
              case 'date':
              case 'datetime-local':
              case 'month':
              case 'week':
              case 'time':
                control.addEventListener('input', (event) => {
                  event.preventDefault();
                  this.changeStateTrailingDebounce(event,true);
                });
                break;
              default:
                control.addEventListener('change', (event) => {
                  this.changeState(event,true,undefined);
                });
                break;
            }
          } else {
            control.addEventListener('change', (event) => {
              this.changeState(event,true,undefined);
            });
          }
          control.setAttribute('data-sg-live-update-listeners-attached', 'true');
        });
        
        const controlCustomAnchors = form.querySelectorAll('[data-sg-live-update-control-params]');
        controlCustomAnchors.forEach((control) => {
          if(control.hasAttribute('data-sg-live-update-listeners-attached')) {
            return false;
          }
          if(!control.hasAttribute('aria-pressed')) {
            //Default pressed state.
            control.setAttribute('aria-pressed', 'false');
          }
          control.addEventListener('click', (event) => {
            event.preventDefault();
            //These controls are designed to be active one at a time, but can provide several parameters at once. They are useful for pagination buttons, where you'd only want one to be active at a time, but provide more than a radio button. If you have a group of pagination buttons and a group of month buttons and want to be able to select only one page and one month simultaneously, you can add a group to data-attribute.
            const btnPrevState = event.currentTarget.getAttribute('aria-pressed') === 'true';
            const btnGroup = event.currentTarget.getAttribute('data-sg-live-update-control-group');
            if(btnGroup) {
              //de-toggle all buttons in this group.
              const controlCustomAnchorsGroup = form.querySelectorAll(`[data-sg-live-update-control-params][data-sg-live-update-control-group=${btnGroup}]`);
              controlCustomAnchorsGroup.forEach((control) => {
                control.setAttribute('aria-pressed', 'false');
              });
            } else {
              //de-toggle all buttons with no group.
              controlCustomAnchors.forEach((control) => {
                control.setAttribute('aria-pressed', 'false');
              });
            }
            if(btnPrevState === false) {
              event.currentTarget.setAttribute('aria-pressed', 'true')
            }
            let resetToFirstPage = false;
            if(!btnGroup || btnGroup != 'page') {
              resetToFirstPage = true;
            }
            this.changeState(event,resetToFirstPage,undefined);
          });
          control.setAttribute('data-sg-live-update-listeners-attached', 'true');
        });

        const controlSort = form.querySelectorAll('[data-sg-live-update-sort-order]');
        controlSort.forEach((control) => {
          if(control.hasAttribute('data-sg-live-update-listeners-attached')) {
            return false;
          }
          control.addEventListener('click', (event) => {
            var t = event.currentTarget;
            var parentTH = t.closest('th');
            var state = t.dataset.sgLiveUpdateSortOrder, newState;
            var activeSort = form.querySelectorAll('[data-sg-live-update-sort-order=asc],[data-sg-live-update-sort-order=desc]');
            activeSort.forEach((item) => {
              var itemParent = item.closest('th');
              if(itemParent) {
                itemParent.removeAttribute('aria-sort');
              }
              item.setAttribute('data-sg-live-update-sort-order', 'unsorted');
              item.innerHTML = this.sortHTML['unsorted'];
            })
            if(state === "unsorted" || state === "desc") {
              newState = "asc";
              if(parentTH) {
                parentTH.setAttribute('aria-sort', 'ascending')
              }
            } else if(state === "asc") {
              newState = "desc";
              if(parentTH) {
                parentTH.setAttribute('aria-sort', 'descending')
              }
            }
            t.setAttribute('data-sg-live-update-sort-order', newState);
            t.innerHTML = this.sortHTML[newState];
            this.changeState(event,false,undefined);
          });
          control.setAttribute('data-sg-live-update-listeners-attached', 'true');
        });
      })
    }
    
  }
  resetToFirstPage() {
    const pageButtons = this.element.querySelectorAll('[data-sg-live-update-control-group=page]');
    pageButtons.forEach((btn) => {
      if(btn.getAttribute('data-sg-live-update-control-params').match(/(?:page=1)(?!\d)/)) {
        btn.setAttribute('aria-pressed', 'true');
      } else {
        btn.setAttribute('aria-pressed', 'false');
      }
    })
  }
  createTrailingDebouncedFunction(func, timeout = 300){
    //from https://www.freecodecamp.org/news/javascript-debounce-example/
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args); 
      }, timeout);
    };
  }
  changeState(event,resetPages = false,options) {
    if(resetPages === true) {
      this.resetToFirstPage();
    }
    const state = this.getFormState(undefined, true);
    this.liveUpdate(state,undefined,undefined,options);
    if(this.modifyHistory) {
      if(this.modifyHistory.enabled === true) {
        let newStateForHistory;
        if(this.modifyHistory.includeHiddenFields === true) {
          newStateForHistory = state;
        } else {
          newStateForHistory = this.getFormState(undefined, false);
        }
        
        let serialisedState = '';
        let sep = '?';
        for(var key in newStateForHistory) {
          if(state[key] && !key.includes('referrerSlug')) {
            serialisedState += `${sep}${key}=${newStateForHistory[key]}`
            sep = '&';
          }
        }
        history.pushState({}, '', `${window.location.pathname}${serialisedState}`);
      }
    }
  }
  removeSuspenseCSS() {
    if(this.suspenseCSSClassList) {
      var classListArray = this.suspenseCSSClassList.split(' ');
      classListArray.forEach((className) => {
        if(this.liveUpdateComponents) {
          this.liveUpdateComponents.forEach((element, index) => {
            element.classList.remove(className)
          });
        } else {
          this.element.classList.remove(className);
        }
      });
    }
  }
}

function init() {
  //Using data-attributes, you can make your code trigger the below initiation script. Removing the data-attributes will mean the script has no effect.
  const layoutSections = document.querySelectorAll('[data-sg-live-update-key]');
  layoutSections.forEach(
    (layoutSection) => {
      //Init
      const modifyHistory = {
        enabled: layoutSection.dataset.sgLiveUpdateModifyHistoryEnabled === 'true' ? true : false,
        includeHiddenFields: layoutSection.dataset.sgLiveUpdateModifyHistoryIncludeHiddenFields === 'true' ? true : false
      }
      const reference = new SitegurusLiveUpdate({element: layoutSection,liveUpdateComponents: Array.from(layoutSection.querySelectorAll('[data-sg-live-update-component]')), autoEventListeners: true, modifyHistory: modifyHistory});
      //Check initial HTML to see if immediate live update is required.
      var state = reference.getFormState(undefined, true);
      var requiresUpdate = false;
      for(var key in state) {
        if(state[key]) {
          requiresUpdate = true;
          break;
        }
      }
      if(requiresUpdate === true) {
        reference.changeState();
      }
    }
  );
  const live_update_script_ready = new CustomEvent("live_update_script_ready");
  document.dispatchEvent(live_update_script_ready);
  window.sgLiveUpdateInitiated = true;
  
}

if (
  document.readyState === 'complete' 
  || document.readyState === 'loaded' 
  || document.readyState === 'interactive'
) {
  //DOM is already ready.
  init();
} else {
  //Set event listener to wait for DOM.
  document.addEventListener('DOMContentLoaded', init);
}

